import { useEffect } from "react";

const useDebouncedAction = (deps: unknown[] = [], callback: () => void, delay = 800) => {
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      callback();
    }, delay);

    return () => clearTimeout(delayDebounceFn);
  }, [...deps]);
};

export default useDebouncedAction;
